import { client } from '@atlassian/rovo-content-bridge-api';
export var SMART_CREATE_MODAL_CLIENT_ID = client('smart-create-modal');